// Autosaved detail forms start empty (undefined) until their record loads, so
// a change away from undefined is the record arriving, not the user editing.
// Loaded-but-empty fields hold null, so a first pick still counts.
const isUserFieldChange = (previousValue, nextValue) =>
  previousValue !== undefined && previousValue != nextValue;

export default isUserFieldChange;
